<template>
  <div class="favourites bg-white">
    <div class="container mx-auto px-3 bg-white">
      <div v-if="message" class="message">{{ message }}</div>
      <div
        v-for="livingOption in structuredPropertyData"
        class="living-option"
        :key="livingOption._id"
      >
        <h2 class="living-option__heading" v-html="livingOption.label.en"></h2>
        <div class="living-option__description" v-html="livingOption.description.en"></div>
        <div class="living-option__buttons">
          <a v-if="livingOption.brochure" :href="$store.state.ASSETS_HOST + livingOption.brochure" target="_blank" class="button mr-3 mb-3">View Brochure (English)</a>
          <a v-if="livingOption.brochureAr" :href="$store.state.ASSETS_HOST + livingOption.brochureAr" target="_blank" class="button mr-3 mb-3">View Brochure (Arabic)</a>
          <button v-if="livingOption.images.length" class="button mr-3 mb-3" @click="openLightboxSlider(livingOption.images.map(image => $store.state.ASSETS_HOST + image))">View Images</button>
          <button v-if="livingOption.videos.length" class="button mr-3 mb-3" @click="openLightboxSlider(livingOption.videos.map(video => $store.state.ASSETS_HOST + video))">{{ `View Video${livingOption.videos.length > 1 ? 's' : ''}` }}</button>
          <a v-if="livingOption.financeGuideEn && hasAvailableProperty" :href="$store.state.ASSETS_HOST + livingOption.financeGuideEn" target="_blank" class="button mr-3 mb-3">
            <div v-if="livingOption._id === '6418eb51d4e46c3a5ce502fa'">Payment Plan (English)</div>
            <div v-else>Tayseer Direct Financing (English)</div>
          </a>
          <a v-if="livingOption.financeGuideAr && hasAvailableProperty" :href="$store.state.ASSETS_HOST + livingOption.financeGuideAr" target="_blank" class="button mr-3 mb-3">
            <div v-if="livingOption._id === '6418eb51d4e46c3a5ce502fa'">Payment Plan (Arabic)</div>
            <div v-else>Tayseer Direct Financing (Arabic)</div>
          </a>
        </div>
        <div class="properties">
          <div
            v-for="property in livingOption.properties"
            class="property"
            :key="property._id"
          >
            <div class="property__body">
              <h3 class="property__heading" v-html="`${property.models[0].type} ${parsePropertyNumber(property.label)}`"></h3>
              <div class="property__subsection-label" v-html="property.subsection.displayName.en"></div>
              <table class="property__details">
                <tr class="property__detail" v-if="property.status !== 'Sold'"><td>Price</td><td>{{ property.price | money }} <span>OMR</span></td></tr>
                <tr class="property__detail"><td>Size</td><td>{{ property.msq }} <span>m<sup>2</sup></span></td></tr>
                <tr class="property__detail"><td>View</td><td>{{ property.view }}</td></tr>
              </table>
              <div class="spacer"></div>
              <div>
                <button
                  v-if="parsePropertyImages(property).length"
                  class="button button--dark"
                  @click="openLightboxSlider(parsePropertyImages(property))"
                >View Floorplan</button>
              </div>
            </div>
            <div class="property__image">
              <v-img :src="getPropertyThumbnail(property)" fit="cover" @click.native="openLightboxSlider(parsePropertyImages(property))"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <lightbox-slider
      :active="isLightboxActive"
      :images="lightboxImages"
      @close="closeLightboxSlider"
    />
  </div>
</template>

<script>
import LightboxSlider from './LightboxSlider'
import VImg from './VImage'
import { mapGetters } from 'vuex'

export default {
  components: { LightboxSlider, VImg },

  data () {
    return {
      isLightboxActive: false,
      lightboxImages: [],
    }
  },

  computed: {
    ...mapGetters([
      'message',
      'structuredPropertyData'
    ]),

    hasAvailableProperty () {
      let hasAvailableProperty = false
      this.structuredPropertyData.forEach(livingOption => {
        livingOption.properties.forEach(property => {
          if (property.status === 'Available') {
            hasAvailableProperty = true
          }
        })
      })
      return hasAvailableProperty
    }
  },

  filters: {
    money (value) {
      if (!value) return ''
      let remaining = value.toString() // initially, the entire value is "remaining"
      let formatted = '' // this is the return value string that we add the formatted '000s to
      while (remaining.length > 3) { // 3 because ,000 (thousand)
        formatted = ',' + remaining.substring(remaining.length - 3, remaining.length) + formatted // , + <next 3 digits> + <any already formatted digits>
        remaining = remaining.substring(0, remaining.length - 3) // remove the last 3 digits from remaining
      }
      formatted = remaining + formatted // < 3 digits left so no more ',' to add
      return formatted
    }
  },

  mounted () {
    setTimeout(() => {
      this.$store.commit('LEADFORM_TIMEOUT_FINISHED')
    }, 3000)
  },

  methods: {
    closeLightboxSlider () {
      this.isLightboxActive = false
      this.lightboxImages = []
    },

    getPropertyThumbnail (property) {
      return this.parsePropertyImages(property)[0]
    },

    openLightboxSlider (images) {
      this.isLightboxActive = true
      this.lightboxImages = images
    },

    parsePropertyImages (property) {
      const propertyModelFloorplans = property.models[0].floorplans.map(image => this.$store.state.ASSETS_HOST + image)
      const subsectionFloorplan = this.$store.state.ASSETS_HOST + property.subsection.backgroundImage
      const propertyViewpointImages = property.images.map(image => this.$store.state.ASSETS_HOST + image)
      const propertyModelGalleryImages = property.models[0].images.map(image => this.$store.state.ASSETS_HOST + image)

      return [  ...propertyModelFloorplans, subsectionFloorplan, ...propertyViewpointImages, ...propertyModelGalleryImages ]
    },

    parsePropertyNumber (value) {
      if (!value) return ''
      let explodedString = value.split('-')
      return explodedString[explodedString.length - 1]
    },
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/_variables';

.favourites {
  padding-top: 30px;
}

.message {
  margin-bottom: 20px;
}

.living-option {
  margin-bottom: 30px;

  &__heading {
    border-top: 1px solid $navy;
    color: $navy;
    font-size: 24px;
    font-weight: 600;
    line-height: 1;
    margin-bottom: 0.8em;
    padding-top: 0.5em;
  }

  &__description {
    max-width: 600px;

    p {
    line-height: 1.4;
    margin-bottom: 30px;
    }
  }

  &__buttons {
    margin-bottom: 15px;
  }
}

.properties {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.property {
  background-color: $navy;
  color: #fff;
  display: flex;
  margin-bottom: 15px;
  padding: 15px;
  width: calc(50% - 7.5px);

  @media (max-width: 1279px) {
    width: 100%;
  }

  @media (max-width: 600px) {
    display: block;
  }

  &__body {
    display: flex;
    flex-direction: column;
    padding: 15px;
    width: 40%;

    @media (max-width: 600px) {
      display: block;
      margin-bottom: 15px;
      padding: 15px 0;
      width: 100%;
    }
  }

  &__heading {
    color: #fff;
    font-size: 18px;
    margin-bottom: 10px;
    text-transform: capitalize;
  }

  &__subsection-label {
    margin-bottom: 15px;
    opacity: 0.8;
  }

  &__details {
    margin-bottom: 15px;
  }

  &__detail {
    margin-bottom: 0.5em;

    td:first-child {
      font-size: 0.8em;
      opacity: 0.6;
      text-align: right;
      text-transform: uppercase;
      padding: 0 10px 10px 0;
    }

    td:last-child {
      opacity: 1;
      width: 100%;

      span {
        font-size: 12px;
        opacity: 0.8;
      }
    }
  }

  &__image {
    cursor: pointer;
    // padding-left: 15px;
    padding-bottom: 35%;
    position: relative;
    width: 60%;

    @media (max-width: 600px) {
      padding-bottom: 0;
      width: 100%;
    }

    .v-img {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;

      @media (max-width: 600px) {
        position: relative;
      }
    }
  }
}

.button {
  background-color: $gold;
  border: none;
  border-radius: 0;
  color: #fff;
  display: inline-block;
  font-family: $font-sans;
  font-size: 12px;
  letter-spacing: 0.1em;
  padding: 0.8em 1.5em;
  text-transform: uppercase;

  &:hover,
  &:focus {
    background-color: lighten($gold, 10%);
    outline: none;
  }

  &--dark {
    background-color: $navy;
    border: 1px solid #fff;
    color: #fff;

    &:hover,
    &:focus {
      background-color: rgba(#fff, 0.2);
      outline: none;
    }    
  }
}

.spacer {
  flex-grow: 1;
}
</style>
